module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.handleCancel($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title text-center"
  }, [_vm._v("Select Phone Number for MFA Texts")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "mb-lg"
  }, [_vm._v("\n          Please select the cell phone number that can receive texts for MFA codes, or edit an existing number to your\n          cell.\n        ")]), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.error))])]), _vm._v(" "), _c('div', {
    staticClass: "phone-selector mb-lg"
  }, [_c('label', {
    staticClass: "phone-option",
    class: {
      'selected': _vm.selectedPhone === 'PRIMARY',
        'editing': _vm.editingPrimary
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPhone),
      expression: "selectedPhone"
    }],
    attrs: {
      "type": "radio",
      "name": "phonePreference",
      "value": "PRIMARY",
      "disabled": !_vm.hasValidPrimaryPhone && !_vm.editingPrimary
    },
    domProps: {
      "checked": _vm._q(_vm.selectedPhone, "PRIMARY")
    },
    on: {
      "__c": function($event) {
        _vm.selectedPhone = "PRIMARY"
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-content"
  }, [_c('div', {
    staticClass: "phone-header"
  }, [_c('strong', [_vm._v("Primary Phone")]), _vm._v(" "), (!_vm.editingPrimary) ? _c('button', {
    staticClass: "btn btn-sm btn-link edit-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.startEditingPrimary($event)
      }
    }
  }, [_vm._v("\n                  Edit\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.editingPrimary) ? _c('div', {
    staticClass: "phone-input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPrimaryPhone),
      expression: "editPrimaryPhone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control phone-input-inline",
    attrs: {
      "id": "editPrimaryPhone",
      "type": "text",
      "placeholder": "(555) 123-4567"
    },
    domProps: {
      "value": (_vm.editPrimaryPhone)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "blur": _vm.stopEditingPrimary,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editPrimaryPhone = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "phone-display-value"
  }, [(_vm.displayPrimaryPhone || _vm.hasExistingPrimaryPhone) ? _c('small', [_vm._v("\n                  " + _vm._s(_vm.displayPrimaryPhone || _vm.formatPhoneForDisplay(_vm.user.primaryPhoneNum)) + "\n                ")]) : _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("(Not set)")])])])]), _vm._v(" "), _c('label', {
    staticClass: "phone-option",
    class: {
      'selected': _vm.selectedPhone === 'SECONDARY',
        'editing': _vm.editingSecondary
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPhone),
      expression: "selectedPhone"
    }],
    attrs: {
      "type": "radio",
      "name": "phonePreference",
      "value": "SECONDARY",
      "disabled": !_vm.hasValidSecondaryPhone && !_vm.editingSecondary
    },
    domProps: {
      "checked": _vm._q(_vm.selectedPhone, "SECONDARY")
    },
    on: {
      "__c": function($event) {
        _vm.selectedPhone = "SECONDARY"
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-content"
  }, [_c('div', {
    staticClass: "phone-header"
  }, [_c('strong', [_vm._v("Secondary Phone")]), _vm._v(" "), (!_vm.editingSecondary) ? _c('button', {
    staticClass: "btn btn-sm btn-link edit-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.startEditingSecondary($event)
      }
    }
  }, [_vm._v("\n                  Edit\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.editingSecondary) ? _c('div', {
    staticClass: "phone-input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editSecondaryPhone),
      expression: "editSecondaryPhone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control phone-input-inline",
    attrs: {
      "id": "editSecondaryPhone",
      "type": "text",
      "placeholder": "(555) 123-4567"
    },
    domProps: {
      "value": (_vm.editSecondaryPhone)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "blur": _vm.stopEditingSecondary,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editSecondaryPhone = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "phone-display-value"
  }, [(_vm.displaySecondaryPhone || _vm.hasExistingSecondaryPhone) ? _c('small', [_vm._v("\n                  " + _vm._s(_vm.displaySecondaryPhone || _vm.formatPhoneForDisplay(_vm.user.secondaryPhoneNum)) + "\n                ")]) : _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("(Not set)")])])])])]), _vm._v(" "), (!_vm.hasValidPrimaryPhone && !_vm.hasValidSecondaryPhone && !_vm.editingPrimary && !_vm.editingSecondary) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("\n          You need at least one phone number for SMS MFA. Please add a phone number above.\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer modal-buttons"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleEmailOnly
    }
  }, [_vm._v("I only want to receive login codes through email")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.canSave
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saving ? 'Saving...' : 'Save') + "\n        ")])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-lg"
  }, [_c('strong', [_vm._v("To keep your account secure, multi-factor authentication through text message is now\n            available.")]), _vm._v(" Standard text message rates from your carrier might apply.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5536ce2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MfaPhonePreferenceDialog.vue
// module id = 2150
// module chunks = 1